import { render, staticRenderFns } from "./NacionalidadeField.vue?vue&type=template&id=60ea1932&"
import script from "./NacionalidadeField.vue?vue&type=script&lang=js&"
export * from "./NacionalidadeField.vue?vue&type=script&lang=js&"
import style0 from "./NacionalidadeField.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports